export const getQueryParams = (search: string): Record<string, string> => {
  const params = new URLSearchParams(search);

  return [...params.entries()].reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
};
